import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import config from '../../config';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import { PotDetailMessages } from './PotDetailMessages';
import { PotDetailMobileMessages } from './PotDetailMobileMessages';
import { CircularProgress } from './CircularProgress';
import BrowserUtils from '../../utils/BrowserUtils';

/**
 * @todo
 * This component is of poor quality.
 * Future refactoring should be done to help address this.
 */
class SavingPotsList extends Component {
  getCurrentPotPage = () => {
    SavingPotsActionCreator.getPotDetail(this.props.pot.id);
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_saving_goal_viewer,
        event: 'click',
      }
    );
  };
  render = () => {
    const {
      content,
      pot: { goalWhen, balance, goalAmount, monthlyContry, name: potName },
    } = this.props;
    const potBalance = parseFloat(balance);
    const potGoal = parseFloat(goalAmount);
    const potScheduleValue = parseFloat(monthlyContry);
    const PotDetailMessagesComponent = BrowserUtils.isMobileView()
      ? PotDetailMobileMessages
      : PotDetailMessages;

    return (
      <a
        href="javascript:void(0);"
        className="row no-gutters saving_pot_item"
        onClick={this.getCurrentPotPage}
      >
        <div className="col-md-3 col-sm-3 col-xs-5 text-center">
          <CircularProgress
            size={this.donutSize}
            potBalance={potBalance}
            potGoal={potGoal}
          />
        </div>
        <div className="col-md-9 col-sm-9 col-xs-7">
          <h4>{potName}</h4>
          <div className="pot-target-date">
            {content.savingpotTargetDate} {moment(goalWhen).format('MMMM YYYY')}
          </div>
          <div className="potMessages">
            <PotDetailMessagesComponent
              amountvalue={potScheduleValue}
              goal={potGoal}
              goalwhen={goalWhen}
              balance={potBalance}
              content={content}
            />
          </div>
        </div>
      </a>
    );
  };
}

SavingPotsList.propTypes = {
  pot: PropTypes.object,
  content: PropTypes.object,
};

export { SavingPotsList };
